import React from 'react';

function ArticleImage({ imageUrl, imageAlt }) {
  if (!imageUrl) { return null; }

  return (
    <p>
      <img src={imageUrl} className="img-responsive" alt={imageAlt} />
    </p>
  );
}

ArticleImage.propTypes = {
  imageUrl: React.PropTypes.string,
  imageAlt: React.PropTypes.string
};

// reload a large background image and replace the small one.
// we reset the react state of the article background value
// to automatically update the component.
// this uses the technique of multiple background image urls.
// the first one is the upper layer. so we replace the small
// background image with a combination of the large and the
// small one. this makes also the firefox present the large
// image smoothly.
function loadLargeImage(component) {
  if (component.state.article.imageBackgroundSrc) {
    const article = component.state.article,
          smallBackground = new Image(),
          largeBackground = new Image(),
          backgroundStylesTeaser = {},
          backgroundStyles = {},
          backgroundPosition = article.imageBackground.backgroundPosition,
          smallestBackgroundUrl = article.imageBackground.backgroundImage;

    smallBackground.src = article.imageBackgroundTeaserSrc;
    smallBackground.onload = () => {
      backgroundStylesTeaser.backgroundImage = `\
        url(${smallBackground.src}),\
        ${smallestBackgroundUrl}\
      `.trim();
      backgroundStylesTeaser.backgroundPosition = backgroundPosition;
      article.imageBackground = backgroundStylesTeaser;
      component.setState({ article });

      largeBackground.src = article.imageBackgroundSrc;
      largeBackground.onload = () => {
        backgroundStyles.backgroundImage = `\
          url(${largeBackground.src}),\
          url(${smallBackground.src}),\
          ${smallestBackgroundUrl}\
        `.trim();
        backgroundStyles.backgroundPosition = backgroundPosition;
        article.imageBackground = backgroundStyles;
        component.setState({ article });
      };
    };
  }
}

export { ArticleImage, loadLargeImage };



// WEBPACK FOOTER //
// ./components/articleImage.js